/*
Back to Top
*/
	// hide #back-top first
	jQuery("#back-top").hide();
	
	// fade in #back-top
	jQuery(function () {
		jQuery(window).on("load scroll", function () {
			if (jQuery(this).scrollTop() > 200) {
				jQuery('#back-top').fadeIn(1600);
			} else {
				jQuery('#back-top').fadeOut(800);
			}
		});

		// scroll body to 0px on click
		jQuery('#back-top').click(function () {
			jQuery('html, body').animate({scrollTop : 0}, 600);
			return false;
		});
	});
/*
Logo Animation effect
*/

	jQuery(function () {
        var logo = jQuery('#logo');
        var logopos = jQuery('.header #logo > li > a');
        var trigger = false;

		jQuery(window).on('load scroll', function () {
			if ((jQuery(this).scrollTop() > 170) && !(trigger)) {
                    logo.addClass('rotated');
                    logopos.css({"top":"-1.3em", "left":"-2.0em"});
                    jQuery('#logo').rotate(-90, {
                        duration: 1000,
                        easing: 'swing',
                        complete: function () {
                            logopos.css({"top":"-1.3em", "left":"-2.0em"});
                            logopos.promise().done(function(){
                                trigger = true;
                                //console.log(trigger);
                            });
                        }
                    });
            } 

            if ((jQuery(this).scrollTop() < 170) && (trigger)) {
                    logo.removeClass('rotated');
                    logopos.css({"top":"0.5em", "left":"0.1em"});
                    jQuery('#logo').rotate(90, {
                        duration: 1000,
                        easing: 'swing',
                        complete: function () {
                            logopos.css({"top":"0.5em", "left":"0.1em"});
                            logopos.promise().done(function(){
                                trigger = false;
                                //console.log(trigger);
                            });
                        }
                    });
            }
		});

    });


